import { Component } from '@angular/core'
import { ColumnControlBaseComponent } from '../base/column-control-base.component'

@Component({
    selector: 'app-column-control-date',
    templateUrl: './column-control-date.component.html',
    styleUrls: ['./column-control-date.component.scss'],
    standalone: false
})
export class ColumnControlDateComponent extends ColumnControlBaseComponent {}
